'use client';

import { Container } from '../../components/ui/container';
import { StartForm } from '../../components/project-register/start-form/start-form';
import { StartSidebar } from '../../components/project-register/start-form/start-sidebar';
import { useStartFormStepper } from '../../hooks/use-start-form-stepper';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { GoSignOut } from 'react-icons/go';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

const StartFormPage = () => {
  const { t } = useTranslations();

  const { currentStep, setStep } = useStartFormStepper();

  return (
    <Container className="flex flex-wrap items-start justify-start gap-6 py-6 sm:gap-8 sm:py-16">
      <div className="flex w-full basis-full items-center justify-start gap-2 sm:justify-between">
        <h1 className="text-3xl font-bold sm:text-4xl md:text-5xl">TODO COMPANY NAME s.r.o.</h1>
        <Button
          className="hidden border border-primary hover:bg-primary/5 sm:flex"
          variant={'outline'}
          asChild
        >
          <a href={ROUTES.SIGN_OUT()} className="flex gap-2">
            <GoSignOut className="h-5 w-5 text-primary" />
            <p className="font-medium text-primary">{t('text258').toUpperCase()}</p>
          </a>
        </Button>
        <a href={ROUTES.SIGN_OUT()} className="sm:hidden">
          <GoSignOut className="h-5 w-5 text-primary" />
        </a>
      </div>
      <div className="flex w-full gap-6 sm:w-auto">
        <StartSidebar
          setStep={setStep}
          currentStep={currentStep}
          className={{ wrapper: 'hidden sm:flex' }}
        />
        <StartForm setStep={setStep} currentStep={currentStep} />
      </div>
    </Container>
  );
};

export default StartFormPage;
